import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { Cluster, Pin, PinBuilding } from './SVGs'

export const buildSiteIcon = (google, markerColor) => {
  const staticElement = renderToStaticMarkup(<Pin id={'pin_site'} fill={markerColor} />)
  const svg = window.btoa(staticElement)

  return {
    url: `data:image/svg+xml;base64,${svg}`,
    scaledSize: new google.maps.Size(26, 34),
  }
}

export const buildBuildingIcon = (google, markerColor) => {
  const staticElement = renderToStaticMarkup(<PinBuilding fill={markerColor} />)
  const svg = window.btoa(staticElement)

  return {
    url: `data:image/svg+xml;base64,${svg}`,
    scaledSize: new google.maps.Size(26, 34),
  }
}

export const buildClusterIcon = (google, clusterColor) => {
  const staticElement = renderToStaticMarkup(<Cluster fill={clusterColor} fillOpacity={0.8}/>)
  const svg = window.btoa(staticElement)

  return {
    url: `data:image/svg+xml;base64,${svg}`,
    scaledSize: new google.maps.Size(52, 40),
  }
}
